<template>
  <v-data-table :headers="headers" :items="computedPoVendors" dense :search="search">
    <template v-slot:top>
      <v-toolbar flat>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-menu
              v-model="menuStartDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                  hide-details
                  clearable
                  @click:clear="startDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-menu
              v-model="menuEndDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                  hide-details
                  clearable
                  @click:clear="endDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="endDate" @input="menuEndDate = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              flat
              dense
              outlined
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ item }">
      {{ computedPoVendors.map(x => x.id).indexOf(item.id) + 1 }}
    </template>
    <template v-slot:item.poNumber="{ item }">
      {{ item.po_number }}{{ item.po_number_seq }}
    </template>
    <template v-slot:item.poDate="{ item }">
      {{ formatDate(item.po_date) }}
    </template>
    <template v-slot:item.currency="{ item }">
      {{ getCurrency(item.details) }}
    </template>
    <template v-slot:item.totalPoQty="{ item }">
      {{ getTotalPoQty(item.details) }}
    </template>
    <template v-slot:item.totalReceivedQty="{ item }">
      {{ getTotalReceivedQty(item.details) }}
    </template>
    <template v-slot:item.totalAmount="{ item }">
      {{ formatPrice(getTotalAmount(item.details)) }}
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip :color="getStatusColor(item.details)" small dark>
        {{ getStatus(item.details) }}
      </v-chip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "PO Number",
        value: "poNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "PO Date",
        value: "poDate",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Currency",
        value: "currency",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Total PO Qty",
        value: "totalPoQty",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Total Received Qty",
        value: "totalReceivedQty",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Total Amount",
        value: "totalAmount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    search: "",
    startDate: null,
    endDate: null,
    menuStartDate: false,
    menuEndDate: false,
  }),

  computed: {
    ...mapState("external", ["poVendors"]),
    computedPoVendors() {
      let filtered = this.poVendors;

      // Filter by date range
      if (this.startDate || this.endDate) {
        filtered = filtered.filter(po => {
          const poDate = moment(po.po_date);

          if (this.startDate && this.endDate) {
            return (
              poDate.isSameOrAfter(moment(this.startDate)) &&
              poDate.isSameOrBefore(moment(this.endDate))
            );
          } else if (this.startDate) {
            return poDate.isSameOrAfter(moment(this.startDate));
          } else if (this.endDate) {
            return poDate.isSameOrBefore(moment(this.endDate));
          }

          return true;
        });
      }

      return filtered;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("external/getPoVendors")
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    getCurrency(details) {
      if (!details || details.length === 0) return "";
      return details[0].curr || "";
    },
    getTotalPoQty(details) {
      if (!details || details.length === 0) return 0;
      return details.reduce((sum, detail) => sum + (detail.qty_pos || 0), 0);
    },
    getTotalReceivedQty(details) {
      if (!details || details.length === 0) return 0;
      return details.reduce((sum, detail) => {
        const received = (detail.qty_pos || 0) - (detail.qty_delivered || 0);
        return sum + received;
      }, 0);
    },
    getTotalAmount(details) {
      if (!details || details.length === 0) return 0;
      return details.reduce((sum, detail) => {
        const amount = (detail.qty_delivered || 0) * (detail.unit_price || 0);
        return sum + amount;
      }, 0);
    },
    getStatus(details) {
      const totalPoQty = this.getTotalPoQty(details);
      const totalReceivedQty = this.getTotalReceivedQty(details);
      const outstanding = totalPoQty - totalReceivedQty;

      return outstanding === 0 ? "Done" : "Outstanding";
    },
    getStatusColor(details) {
      const status = this.getStatus(details);
      return status === "Done" ? "success" : "warning";
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(4).split(".");
      val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return val.join(",");
    },
  },
};
</script>

<style></style>
